import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';
import generateRangePicker from 'antd/es/date-picker/generatePicker/generateRangePicker';
const RangePicker = generateRangePicker<Date>(dateFnsGenerateConfig);

export default RangePicker;
